import ScreenLock from '../../constants/lock-screen';
class VideoLightbox {
    constructor() {
        Object.defineProperty(this, "btnOpenLightbox", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lightboxClose", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lightboxWrapper", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "player", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.btnOpenLightbox = document.querySelectorAll('.play-video');
        this.lightboxClose = document.querySelectorAll('.block-video__lightbox-close');
        this.lightboxWrapper = document.querySelector('.block-video__lightbox-wrapper');
        this.player = document.querySelector('#player');
    }
    init() {
        for (const button of this.btnOpenLightbox) {
            button.addEventListener('click', this.openLightbox.bind(this));
        }
        for (const button of this.lightboxClose) {
            button.addEventListener('click', this.closeLightbox.bind(this));
        }
        document.addEventListener('keydown', this.keyPressDispatcher.bind(this));
    }
    openLightbox(event) {
        event.preventDefault();
        const target = event.target;
        let url = '';
        if (target.dataset.video) {
            url = target.dataset.video;
        }
        else {
            const title = target.querySelector('.c-btn-title');
            if (title) {
                url = title.dataset.video ?? '';
            }
        }
        let playlist;
        if (url.includes('.m3u8')) {
            playlist = [
                {
                    file: url,
                    title: '',
                },
            ];
        }
        else if (url.includes('.json')) {
            playlist = url;
        }
        if (this.player) {
            jwplayer(this.player).setup({
                playlist: playlist,
                mute: false,
                repeat: false,
                stretching: 'uniform',
            });
        }
        this.lightboxWrapper?.classList.add('active');
        ScreenLock.lock();
    }
    closeLightbox() {
        if (this.player) {
            jwplayer(this.player).stop();
        }
        this.lightboxWrapper?.classList.remove('active');
        ScreenLock.unlock();
    }
    keyPressDispatcher(event) {
        if (event.key === 'Escape') {
            this.closeLightbox();
        }
    }
}
export default new VideoLightbox();
